export function loadFonts({
    fontFiles,
    publicPath = '',
    unicodeRange = 'U+000-5FF',
    fontFamilyFilter = null,
} = {}) {
    if (!fontFiles || typeof fontFiles !== 'object') {
        console.warn('[loadFonts] No font files provided or invalid structure.');
        return;
    }

    function parseFontFilename(filename) {
        const match = filename.match(/\/([A-Za-z0-9_-]+)-(\d{3,4}[iI]?)\.woff2$/);
        if (!match) return null;

        const fontFamily = match[1];
        const variant = match[2];
        const italic = variant.toLowerCase().endsWith('i');
        const fontWeight = italic ? variant.slice(0, -1) : variant;
        const fontFile = filename.split('/').pop();

        return {
            fontFamily,
            fontWeight,
            fontStyle: italic ? 'italic' : 'normal',
            fontFile
        };
    }

    const style = document.createElement('style');
    style.type = 'text/css';

    const css = Object.entries(fontFiles)
        .map(([filePath, url]) => {
            const meta = parseFontFilename(filePath);
            if (!meta) return `/* Invalid font file: ${filePath} */`;
            if (fontFamilyFilter && !fontFamilyFilter(meta.fontFamily)) return '';

            return `
@font-face {
  font-family: '${meta.fontFamily.replace(/'/g, "\\'")}';
  src: url('${publicPath}${meta.fontFile}') format('woff2');
  font-weight: ${meta.fontWeight};
  font-style: ${meta.fontStyle};
  font-display: swap;
}`;
        })
        .filter(Boolean)
        .join('\n');

    if (css.trim().length === 0) {
        console.warn('[loadFonts] No valid @font-face rules were generated.');
        return;
    }

    style.textContent = css;
    document.head.appendChild(style);
}
